import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {

  constructor(
    private router: Router,
  ) { }

  /**
   * Start or continue the Roughcheck assessment by
   * going to the assessment profile
   */
  clickNext() {
    this.router.navigate(['/start']);
  }
}
